import clsx from 'clsx';
import Image, { StaticImageData } from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface CardImageProps {
  className?: string;
  src: StaticImageData | string;
  alt?: string;
}

const CardImagePointingRight: React.FC<CardImageProps> = ({ className, src, alt = '' }) => {
  const [hasLoaded, setHasLoaded] = React.useState(false);
  return (
    <div className={twMerge(clsx('translate-opacity relative h-70 w-70', hasLoaded ? 'opacity-100' : 'opacity-0', className))}>
      <Image
        className='object-contain pr-7'
        alt={alt}
        src={src}
        fill
        sizes='(max-width: 640px) 50vw, (max-width: 828px) 40vw, 100vw'
        onLoad={() => setHasLoaded(true)}
      />
    </div>
  );
};

export default CardImagePointingRight;
